import { createSlice } from '@reduxjs/toolkit'

const teamsCacheSlice = createSlice({
  name: 'teamsCache',
  initialState: {
    byKey: {},
  },
  reducers: {
    cacheTeamsForQuery: (state, action) => {
      const { key, items } = action.payload || {}

      if (!key || !Array.isArray(items)) {
        return
      }

      state.byKey[key] = {
        items,
        cachedAt: Date.now(),
      }
    },
    clearTeamsCache: state => {
      state.byKey = {}
    },
  },
})

export const { cacheTeamsForQuery, clearTeamsCache } = teamsCacheSlice.actions

export const selectTeamsCacheByKey = state => state.teamsCache.byKey

export default teamsCacheSlice.reducer
